var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.374985C4.68477 0.374985 0.375 4.68475 0.375 9.99998C0.375 15.3152 4.68477 19.625 10 19.625C15.3152 19.625 19.625 15.3152 19.625 9.99998C19.625 4.68475 15.3152 0.374985 10 0.374985ZM10 17.9922C5.58711 17.9922 2.00781 14.4129 2.00781 9.99998C2.00781 5.58709 5.58711 2.0078 10 2.0078C14.4129 2.0078 17.9922 5.58709 17.9922 9.99998C17.9922 14.4129 14.4129 17.9922 10 17.9922Z",
    fill: "#701A82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 6.21873C8.96875 6.49224 9.0774 6.75454 9.2708 6.94794C9.46419 7.14134 9.7265 7.24998 10 7.24998C10.2735 7.24998 10.5358 7.14134 10.7292 6.94794C10.9226 6.75454 11.0312 6.49224 11.0312 6.21873C11.0312 5.94523 10.9226 5.68293 10.7292 5.48953C10.5358 5.29613 10.2735 5.18748 10 5.18748C9.7265 5.18748 9.46419 5.29613 9.2708 5.48953C9.0774 5.68293 8.96875 5.94523 8.96875 6.21873ZM10.5156 8.62498H9.48438C9.38984 8.62498 9.3125 8.70233 9.3125 8.79686V14.6406C9.3125 14.7351 9.38984 14.8125 9.48438 14.8125H10.5156C10.6102 14.8125 10.6875 14.7351 10.6875 14.6406V8.79686C10.6875 8.70233 10.6102 8.62498 10.5156 8.62498Z",
    fill: "#701A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.018d1d85.svg";
export { ForwardRef as ReactComponent };